<template>
  <div class="font">
    <span>系统维护中，暂停使用</span>
    <br />
    <br />
    <a href="https://ammeter0.zg118.com/static/Manage/login.html">点击此处进入旧版管理平台</a>
  </div>
</template>

<script>
  export default {
    name: "NoLogin"
  }
</script>

<style scoped>
  .font{
    text-align: center;
    margin-top:15%;
    font-size:20px;
  }
  a{
    color: #af54ff;
  }
  a:hover{
    color:#409eff;
    text-decoration:underline;
  }
</style>